import React ,{useState,useEffect}from "react";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";

import traditionalFlower from "../../assets/traditionalPatternleft.png";
import logo from "../../assets/Mobile logo 1 - XL (1).png";
import lostWay from "../../assets/pageNotFound.png";
import * as func from "../../api/apiHelper"

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = func.getAccessToken();
    if (!token) {
      navigate("/login");
    }

  }, []);

  return (
    <div className="relative flex items-center justify-center min-h-screen bg-[#19224B] ">
      {/* Top right image */}
      <img
        src={traditionalFlower}
        alt="Traditional Flower Top Right"
        className="absolute top-0 right-0 w-1/4"
        style={{ transform: "rotate(180deg)" }}
      />

      <div className="w-full max-w-xl p-8">
        <div className="flex justify-center mb-1 ">
          <img
            src={logo}
            alt="Brand Logo"
            className="h-14 "
            style={{ height: "50px" }}
          />
        </div>

        <div className="mt-6 ">
          <img src={lostWay} alt="page-not-found" className="rounded-xl" />
        </div>

        <form className="mt-6">
          <Button
            type="button"
            onClick={() => {
             
                navigate("/dashboard");

            }}
            className="w-full mt-6 text-white"
            style={{
              background:
                "linear-gradient(278.53deg, #D4A84D 41.62%, #FCE29B 89.24%)",
              border: "none",
              borderRadius: "0.375rem",
              outline: "none",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#FCE29B";
              e.target.style.outline = "none";
            }}
          >
            Go Back
          </Button>
        </form>
      </div>

      {/* Bottom left image */}
      <img
        src={traditionalFlower}
        alt="Traditional Flower Bottom Left"
        className="absolute bottom-0 left-0 w-1/4"
      />
    </div>
  );
};

export default PageNotFound;
